@if (widget.iframe) {
  <iframe [src]="url" frameborder="0" width="100%" height="100%" allowtransparency></iframe>
}
